package com.iptvplayer.web.ui

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun AuthShell(title: String, subtitle: String, onBack: (() -> Unit)? = null, content: @Composable () -> Unit) {
    Div(attrs = {
        classes("hero-bg")
        style {
            minHeight(100.vh)
            display(DisplayStyle.Flex)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            property("padding", "20px")
        }
    }) {
        Div(attrs = {
            style {
                width(100.percent)
                property("max-width", "380px")
                cardStyle()
                property("padding", "30px")
                property("background", "rgba(20,20,26,.85)")
                property("backdrop-filter", "blur(8px)")
            }
        }) {
            if (onBack != null) {
                A(href = "#", attrs = {
                    onClick { it.preventDefault(); onBack() }
                    style { property("color", Theme.textDim); property("font-size", "13px"); property("text-decoration", "none"); property("display", "inline-block"); property("margin-bottom", "14px") }
                }) { Text("← Back to home") }
            }
            Div(attrs = {
                style {
                    display(DisplayStyle.Flex)
                    alignItems(AlignItems.Center)
                    property("gap", "10px")
                }
            }) {
                Span(attrs = { style { property("font-size", "26px") } }) { Text("📺") }
                Span(attrs = { style { property("font-weight", "700"); property("font-size", "20px") } }) { Text("IPTV Player") }
            }
            H1(attrs = { style { property("font-size", "22px"); property("margin", "16px 0 4px") } }) { Text(title) }
            P(attrs = {
                style { property("color", Theme.textDim); property("margin", "0 0 22px"); property("font-size", "14px") }
            }) { Text(subtitle) }
            content()
        }
    }
}
